import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseNtp from '../../AbstractObjects/GatewayPlan/InnerPages/BaseNtp';
import Indentation from '../../../../components/Simple/Indentation';
import SMCLink from '../../../../components/Simple/SMCLink';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {useTranslation} from 'react-i18next';
import {doSeamlessLogin} from '../../../../utils/utils';
import {ntpIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.ntp;
const pageId = pageSchema.pageId;

function GatewayNtp({
    gatewayObject,
    planObject,
    setGatewayData
}) {
    const { t } = useTranslation();

    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }


    const setPageValue = useCallback((param, newValue) => {
        setGatewayData([pageId, param], newValue);
    }, [setGatewayData]);

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setPageValue(pageSchema.manageInSmp, planPage[pageSchema.manageInSmp]);
            setPageValue(pageSchema.primaryNtpServer, planPage[pageSchema.primaryNtpServer]);
            setPageValue(pageSchema.secondaryNtpServer, planPage[pageSchema.secondaryNtpServer]);
            setPageValue(pageSchema.updateIntervalMinutes, planPage[pageSchema.updateIntervalMinutes]);
            setPageValue(pageSchema.ntpAuthentication, planPage[pageSchema.ntpAuthentication]);
            setPageValue(pageSchema.sharedSecret, planPage[pageSchema.sharedSecret]);
            setPageValue(pageSchema.sharedSecretIdentifier, planPage[pageSchema.sharedSecretIdentifier]);
        }
        setPageValue(pageSchema.lockedToPlan, locked);
    }, [setPageValue, planPage]);


    return (
        <>
            <LockToPlanContainer
                locked={lockedToPlan}
                onToggleLocked={onToggleLockedToPlan}
                labelText={t('SMP.GATEWAYS.INNER_MENU.NTP')}
                icon={ntpIcon}
            >
                <BaseNtp
                    pageData={currentPageData}
                    setObjectData={setGatewayData}
                    pageDisabled={lockedToPlan}
                />
            </LockToPlanContainer>
            <Indentation>
                <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.DateAndTime')}>
                    <SMCIcon style={{verticalAlign: 'middle'}} icon="seamlessLogin"/>
                    {t('SMP.PLAN.NEW_PLAN_DS.NTP.AG_DATE_AND_TIME')}
                </SMCLink>
            </Indentation>
        </>
    );
}

export default GatewayNtp;